import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const UAPI_URL = process.env.REACT_APP_UAPI_URL

export const config = {
  headers: {
    Authorization: null,
  },
}

// generate the token
export const getToken = async (callback) => {
  try {
    const res = await axios.get(`${API_URL}/generate/token`)
    const { data = {} } = res
    if (data && data.token) config.headers.Authorization = data.token
    if (callback) callback(data.token)
    return data
  } catch (error) {
    if (error) console.error(error)
  }
}

// check if user already have a booking
export const getUserBooking = async (formData) => {
  try {
    const { data } = await axios.get(`${API_URL}/club-user-bookings`, {
      ...config,
      params: formData,
    })
    return data
  } catch (error) {
    if (error) console.error(error)
  }
}

// check if user already agreed with the user agreement
export const getUserSignedAgreement = async (params) => {
  try {
    const { data } = await axios.get(`${API_URL}/club-user-signed-agreement`, {
      ...config,
      params,
    })
    return data
  } catch (error) {
    if (error) console.error(error)
  }
}

// create record that the user agree with the agreement
// {
//     "phone": "+61499150625",
//     "club_id": "TestClubAU",
//     "clubUserAgreementId": "f47abe99-4f0a-4c01-8c60-7b5e77308a56",
//     "countryCode": "AU",
//     "agreed": 1, // 1 || 0
//     "signedBy": "Rowell Dinglasa", // full name
//     "signedEmail": "test@gmail.com", // user email
//     "createBookings": true // this field is optional. only add this when user doesn't have a booking
// }
export const userSignedAgreement = async (formData) => {
  try {
    const { data } = await axios.post(
      `${API_URL}/club-user-signed-agreement`,
      formData,
      config
    )
    return data
  } catch (error) {
    if (error) console.error(error)
  }
}

// get clubUserAgreementId
export const getClubUserAgreement = async (clubId) => {
  try {
    const { data } = await axios.get(
      `${API_URL}/club-user-agreement/${clubId}`,
      { ...config }
    );
    return data
  } catch (error) {
    if (error) console.error(error)
  }
}

export const fetchClub = async (query) => {
  try {
    const response = await axios.get(`${UAPI_URL}/api/v2/club/data?club=${query}`)
    if (!response.data.clubs.length) return {}

    return response.data.clubs[0]
  } catch (error) {
    return {}
  }
}


export const fetchTrackingCodes = async (clubID) => {
  try {
    const response = await axios.get(`${UAPI_URL}/api/v1/customtracking/${clubID}`);
    return response.data;
  } catch (error) {
    return null;
  }
};